import logo from './logo.svg';
import './App.css';
import { Button, Navbar, Nav, NavDropdown, Container } from 'react-bootstrap'
import React, { useState } from 'react';
import Data from './data.js';
import Detail from './Detail.js';
import { Link, Route, Switch } from 'react-router-dom';
import axios from 'axios';

function App() {

  let [shoes, shoes변경] = useState(Data);
  let [재고, 재고변경] = useState([11,12,13]);
  return (
    <Switch>
    <div className="App">
        {<네브바 />}

      <Route exact path="/">
        {<점보트론 />}
        <div className="container">
          <div className="row">
            {
              shoes.map((a, b)=> {
                return (
                  <상품 shoes={shoes[b]} key={b}></상품>
                )
              })

            }
          </div>
        </div>
        <div>
        <button className="btn btn-primary" onClick={()=>{
         //axios.post('url',{ id : 'myid123', pw : 1234});
         
         axios.get('https://codingapple1.github.io/shop/data2.json')
          .then((result)=>{    
            shoes변경([...shoes,...result.data]);
            //console.log(result);
          })
          .catch(()=>{
            console.log("실패했어요");
          })
        }}>더보기</button>
      </div>
      </Route>


      <Route path="/detail/:id">
        <Detail shoes={shoes} 재고={재고}/>
      </Route>
     
    </div>
    </Switch>
  );
}



function 상품(props) {
  return (
    <div className="col-md-4">
      <Link to = {"/detail/"+props.shoes.id}>
        <img src={"https://codingapple1.github.io/shop/shoes"+(props.shoes.id+1)+".jpg"} width="100%"></img>
      </Link>
      <h4>{props.shoes.title}</h4>
      <p>{props.shoes.content} & {props.shoes.price}</p>
    </div>
  )
}


function 네브바() {
  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand href="/">BOSONG'S SHOP</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to ="/">Home</Nav.Link>
            <Nav.Link as={Link} to ="/detail">Detail</Nav.Link>
            <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

function 점보트론() {
  return (
    <div className="Jumbotron">
      <h4>Hello, Song!!</h4>
      This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.
      <hr />
      It uses utility classes for typography and spacing to space content out within the larger container.
      <br />
      <p><Button variant="success">Success</Button>{' '}</p>
    </div>
  )
}
export default App;
